import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKindvriendelijk = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      d="m16.75 14.144 1.083-2.616h3.25l9.75 14.75-3.25 2.71z"
    />
    <path
      fill="#00C5F2"
      d="M27.583 28.988v-4.333H33v4.333z"
    />
    <path
      fill="#85E3F9"
      d="M7 11.528h13v17.333H7z"
    />
    <circle
      cx={12.958}
      cy={18.57}
      r={2.708}
      fill="#00C5F2"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKindvriendelijk);

export default ForwardRef;
